/**
 * Redux Store Configuration
 * - Central state management for the app
 * - Includes all feature slices
 */

import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./slices/userSlice";
import consultationReducer from "./slices/consultationSlice";
import blogsCommunityReducer from "./slices/blogsCommunitySlice";
import petFinderReducer from "./slices/petFinderSlice";
import petPlacesReducer from "./slices/petPlacesSlice";
import paymentReducer from "./slices/paymentSlice";
import dashboardReducer from "./slices/dashboardSlice";
import authReducer from "./slices/authSlice";
import servicesReducer from "./slices/servicesSlice";

export const store = configureStore({
  reducer: {
    users: userReducer,
    consultations: consultationReducer,
    blogsCommunity: blogsCommunityReducer,
    petFinder: petFinderReducer,
    petPlaces: petPlacesReducer,
    payment: paymentReducer,
    dashboard: dashboardReducer,
    auth: authReducer,
    services: servicesReducer,
  },
});
